import {
  COOKIE_ITEMS,
  getCookieItem,
  setCookieItem,
} from '@/utils/cookieControl';
import { useEffect, useState } from 'react';

export const useTechStackFreeCountCheck = (techstackId: string) => {
  const [disabled, setDisabled] = useState(true);

  useEffect(() => {
    freeCountCheck() ? setDisabled(false) : setDisabled(true);
  }, [techstackId]);

  const freeCountCheck = () => {
    if (!getCookieItem(COOKIE_ITEMS.counter)) {
      setCookieItem(COOKIE_ITEMS.counter, 3, 14400);
      return true;
    } else if (Number(getCookieItem(COOKIE_ITEMS.counter)) > 0) {
      setCookieItem(
        COOKIE_ITEMS.counter,
        Number(getCookieItem(COOKIE_ITEMS.counter)) - 1,
        14400
      );
      return true;
    } else {
      return false;
    }
  };

  return disabled;
};
